
class LicensesDetailInfoDataSource extends MIOObject
{
    private tableView:UITableView = null;
    private delegate:LicenseDetailInfoCellDelegate = null;
    initWithTableView(tableView:UITableView, delegate:LicenseDetailInfoCellDelegate) {
        this.tableView = tableView;
        this.delegate = delegate;
    }

    private businessLicense:BusinessLicense = null;
    set business(item:BusinessLicense) {
        this.businessLicense = item;
    }

    private license:License = null;
    set item(item:License) {
        this.license = item;
        this.tableView.reloadData();
    }

    numberOfSections(tableview:UITableView){
        return this.license == null ? 1 : 2;
    }

    numberOfRowsInSection(tableview:UITableView, section:number){
        return 1;
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        if (indexPath.section == 0) {
            let cell = tableview.dequeueReusableCellWithIdentifier("AccountInfoCell") as LicenseAccountInfoCell;
            cell.item = this.businessLicense;
            return cell;
        }

        let cell = tableview.dequeueReusableCellWithIdentifier("LicenseDetailInfoCell") as LicenseDetailInfoCell;

        cell.item = this.license;
        cell.delegate = this.delegate;

        return cell;
    }
}

interface LicenseDetailInfoCellDelegate 
{
    didChangePrice(license:License, price:number):void;
    didChangeDiscount(license:License, discount:string):void;
    didChangeTotal(license:License, total:number):void;
    didChangeFee(license:License, fee:string):void;
    didChangeSeasonal(license:License, seasonal:boolean):boolean;
    didSelectSeasonMonths(license:License, sourceView:MUIView, changed:() => void):void;
    didSelectSeason(license:License):void;

}

